import { setUserToState } from 'store/actions'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import UniqueId from '../../../assets/img/icons/generate-unique-id.svg'
import { t } from 'multi-language/multi-lang.service'
const MAX_UNIQUE_LENGTH = 6

function UniqDoctorId({ user, setUser }) {
    const [uniqueIdList, setUniqueIdList] = useState([])
    const [uniqueId, setUniqueId] = useState()
    const [uniqueIdError, setUniqueIdError] = useState('')
    const dispatch = useDispatch()

    const isUniqueValid = (value) => {
        const alphanumericRegex = /^[0-9A-Za-z]{6}$/
        if (!alphanumericRegex.test(value)) {
            setUniqueIdError(t('doctor.registration.errors.unique_invalid'))
            return false
        } else if (uniqueIdList.includes(value)) {
            setUniqueIdError(t('doctor.registration.errors.unique_exist'))
            return false
        } else {
            setUniqueIdError('')
            return true
        }
    }

    const handleChange = (value) => {
        if(value.length > MAX_UNIQUE_LENGTH) return
        setUniqueId(value)
        isUniqueValid(value)
    }

    const getAllUniqueIds = async () => {
        const uniqueIds = []
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/app/doctor/get-all-unique-ids`, { headers: { 'Authorization': `Bearer ${user.jwtToken}` } })
        if (res?.data?.message) {
            return
        }
        res.data.map(d => uniqueIds.push(d.unique_id))
        setUniqueIdList(uniqueIds)
    }

    useEffect(() => {
        getAllUniqueIds()
    }, [])

    const generateCode = () => {
        const alphanumericChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let code = '';
        while (code.length < MAX_UNIQUE_LENGTH) {
            code += alphanumericChars.charAt(Math.floor(Math.random() * alphanumericChars.length));
        }
        if (isUniqueValid(code)) {
            setUniqueId(code)
        } else {
            generateCode()
        }
        return code;
    }

    const save = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/app/doctor/update-unique-id`, { user_id: user.data.userId, unique_id: uniqueId }, { headers: { 'Authorization': `Bearer ${user.jwtToken}` } })
            if (res?.data?.message) {
                return
            }
            setUser({ ...user, data: { ...user.data, uniqueId: res.data.unique_id } })
            dispatch(setUserToState({ ...user, data: { ...user.data, uniqueId: res.data.unique_id } }))
        } catch (error) {
            console.log('error', error)
        }

    }

    return (
        <div id='unique-doctor-id' className='unique-section card row'>
            <div className='unique-title'>{t('doctor.registration.unique_create')}</div>
            <div className='unique-discreption'>{t('doctor.registration.unique_desc')}</div>
            <div className='unique-line'> </div>
            <div className='unique-user-section'>
                <div className='unique-user-id'>{t('personal_info.unique_id')}</div>
                <div>
                    <input id='unique-doc-input' type='text' value={uniqueId} className='unique-input' placeholder='Xx1234' onChange={e => handleChange(e.target.value)} />
                    {uniqueIdError ? <div className='unique-id-error'>{uniqueIdError}</div>
                        :
                        uniqueId &&
                        <div className='unique-id-valid'>{t('doctor.registration.unique_ok')}</div>
                    }
                </div>
            </div>
            <div className='code-requirement'>
                <div className='generate-code-container' onClick={generateCode}>
                    <img className='generate-img' src={UniqueId} alt='uniqueId' />
                    <div className='generate-code'>{t('doctor.registration.unique_generate')}</div>
                </div>
                <li className='characters-only'>{t('doctor.registration.unique_length')}</li>
                <li className='letters-numbers'>{t('doctor.registration.unique_chars')}</li>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button className='btn-submit' disabled={!uniqueId || uniqueIdError} onClick={() => save()}>{t('general_words.submit')}</Button>
            </div>
        </div>
    )
}

export default UniqDoctorId